import { simpleRequest, request } from '../request';
import qs from 'qs';

type OverviewAppType = 'abtest_app' | 'custom_event' | 'store';
type OverviewChannelType = 'authority' | 'all';
type OverviewAppVersionType = 'mongo' | 'reportDaily';
type ChannelSourceSegmentType = 'campaign' | 'adgroup' | 'creative';
type OverviewAdFilterOptions = {
  adPlacements?: string[];
  adMediations?: string[];
  adNetworks?: string[];
};

export function fetchOverviewAuthorizedApps(type?: OverviewAppType) {
  return simpleRequest<Api.Application.Application[]>({
    url: '/overview/listAuthorizedApps',
    method: 'get',
    params: type ? { type } : undefined
  });
}

export function fetchOverviewCountries() {
  return request<Api.Statistic.CountryName[]>({
    url: '/overview/listCountries',
    method: 'get'
  });
}

export function fetchOverviewChannels(type?: OverviewChannelType) {
  return request<string[]>({
    url: '/overview/listChannels',
    method: 'get',
    params: type ? { type } : undefined
  });
}

export function fetchOverviewAppVersions(
  ids: string[],
  options: {
    type?: OverviewAppVersionType;
    dateFrom?: string;
    dateTo?: string;
  } = {}
) {
  return simpleRequest<string[]>({
    url: '/overview/listAppVersions',
    method: 'get',
    params: { ids, ...options },
    paramsSerializer: function (params: any) {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    }
  });
}

export function fetchOverviewChannelSourceSegment(params: {
  type: ChannelSourceSegmentType;
  appids?: string[];
  channels?: string[];
  campaignIds?: string[];
  adgroupIds?: string[];
  creativeIds?: string[];
  start?: string;
  end?: string;
}) {
  return request<unknown[]>({
    url: '/overview/listChannelSourceSegment',
    method: 'get',
    params,
    paramsSerializer: function (p: any) {
      return qs.stringify(p, { arrayFormat: 'repeat' });
    }
  });
}

export function fetchOverviewMaterialVersions(appids: string[]) {
  return request<Array<{ appId: string; materialVersions: string[] }>>({
    url: '/overview/listMaterialVersions',
    method: 'get',
    params: { appids },
    paramsSerializer: function (params: any) {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    }
  });
}

export function fetchOverviewTags() {
  return request<string[]>({
    url: '/overview/listTags',
    method: 'get'
  });
}

export function fetchOverviewDevelopers() {
  return request<string[]>({
    url: '/overview/getDevelopers',
    method: 'get'
  });
}

export function fetchOverviewStoreAppVersions(appids?: string[]) {
  return request<Api.Application.AppVersionInfo[]>({
    url: '/overview/listStoreAppVersions',
    method: 'get',
    params: appids?.length ? { appids } : undefined,
    paramsSerializer: function (p: any) {
      return qs.stringify(p, { arrayFormat: 'repeat' });
    }
  });
}

export function fetchOverviewABTestGroups(appid: string) {
  return request<any>({
    url: '/overview/listABTestGroups',
    method: 'get',
    params: { appid }
  });
}

export function fetchOverviewEventNames(appid: string) {
  return request<string[]>({
    url: '/overview/listEventNames',
    method: 'get',
    params: { appid }
  });
}

export function fetchOverviewAdFilterOptions(appids?: string[]) {
  return request<OverviewAdFilterOptions>({
    url: '/overview/listAdFilterOptions',
    method: 'get',
    params: appids?.length ? { appids } : undefined,
    paramsSerializer: function (params: any) {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    }
  });
}

export function fetchOverviewLevelFilterOptions(params: {
  type: 'app';
}): ReturnType<typeof simpleRequest<Api.Application.Application[]>>;
export function fetchOverviewLevelFilterOptions(params: {
  type: 'country' | 'channel' | 'version';
  appid: string;
  start: number;
  end: number;
}): ReturnType<typeof request<string[]>>;
export function fetchOverviewLevelFilterOptions(params: {
  type: 'app' | 'country' | 'channel' | 'version';
  appid?: string;
  start?: number;
  end?: number;
}) {
  return request({
    url: '/overview/listLevelFilterOptions',
    method: 'get',
    params
  });
}
